import { useState, useRef, useEffect } from 'react';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { calculateTicketMedio, calculatePercentualReceita } from '../../../core/utils/osReport';

const ReportsTableFooter = ({ totals, counts, formatCurrency }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const lastRowRef = useRef(null);
  const previousExpandedState = useRef(isExpanded);

  useEffect(() => {
    // Só faz scroll quando expande (não quando colapsa)
    if (isExpanded && !previousExpandedState.current && lastRowRef.current) {
      // Pequeno delay para garantir que o conteúdo foi renderizado
      const scrollTimeout = setTimeout(() => {
        if (lastRowRef.current) {
          lastRowRef.current.scrollIntoView({
            behavior: 'smooth',
            block: 'end',
            inline: 'nearest'
          });
        }
      }, 100);

      // Cleanup do timeout
      return () => clearTimeout(scrollTimeout);
    }
    previousExpandedState.current = isExpanded;
  }, [isExpanded]);
  const ticketMedio = calculateTicketMedio(totals, counts);
  const percentualReceita = calculatePercentualReceita(totals);

  return (
    <>
      <div className="reports-table-footer reports-table-footer-totals" onClick={() => setIsExpanded(!isExpanded)}>
        <div className="footer-cell footer-cell-expandable">
          <div className="footer-label">TOTAIS</div>
          {isExpanded ? (
            <FaChevronUp className="expand-icon" />
          ) : (
            <FaChevronDown className="expand-icon" />
          )}
        </div>
        <div className="footer-cell"></div>
        <div className="footer-cell footer-cell-right">
          {formatCurrency(totals.mo_lataria)}
        </div>
        <div className="footer-cell footer-cell-right">
          {totals.qtd_horas_lataria.toFixed(2)}
        </div>
        <div className="footer-cell footer-cell-right">
          {totals.qtd_pecas_pintadas.toFixed(0)}
        </div>
        <div className="footer-cell footer-cell-right">
          {formatCurrency(totals.mo_estetica)}
        </div>
        <div className="footer-cell footer-cell-right">
          {totals.qtd_horas_estetica.toFixed(2)}
        </div>
        <div className="footer-cell footer-cell-right">
          {formatCurrency(totals.valor_pecas)}
        </div>
        <div className="footer-cell footer-cell-right">
          {formatCurrency(totals.custo_pecas)}
        </div>
        <div className="footer-cell footer-cell-right">
          {formatCurrency(totals.lucro_pecas)}
        </div>
        <div className="footer-cell footer-cell-right footer-cell-total">
          {formatCurrency(totals.total_os)}
        </div>
        <div className="footer-cell"></div>
        <div className="footer-cell footer-cell-last"></div>
      </div>

      {isExpanded && (
        <div className="reports-table-footer reports-table-footer-counts">
          <div className="footer-cell">
            <div className="footer-label">QTD ORDENS DE SERVIÇOS</div>
          </div>
        <div className="footer-cell"></div>
        <div className="footer-cell footer-cell-right">
          {counts.qtd_os_funilaria}
        </div>
        <div className="footer-cell"></div>
        <div className="footer-cell"></div>
        <div className="footer-cell footer-cell-right">
          {counts.qtd_os_servicos}
        </div>
        <div className="footer-cell"></div>
        <div className="footer-cell footer-cell-right">
          {counts.qtd_os_pecas}
        </div>
        <div className="footer-cell"></div>
        <div className="footer-cell"></div>
        <div className="footer-cell footer-cell-right footer-cell-total">
          {counts.qtd_os_total}
        </div>
          <div className="footer-cell"></div>
          <div className="footer-cell footer-cell-last"></div>
        </div>
      )}

      {isExpanded && (
        <div className="reports-table-footer reports-table-footer-counts">
          <div className="footer-cell">
            <div className="footer-label">TICKET MÉDIO</div>
          </div>
        <div className="footer-cell"></div>
        <div className="footer-cell footer-cell-right">
          {formatCurrency(ticketMedio.mo_lataria)}
        </div>
        <div className="footer-cell footer-cell-right">
          {formatCurrency(ticketMedio.qtd_horas_lataria)}
        </div>
        <div className="footer-cell footer-cell-right">
          {formatCurrency(ticketMedio.qtd_pecas_pintadas)}
        </div>
        <div className="footer-cell footer-cell-right">
          {formatCurrency(ticketMedio.mo_estetica)}
        </div>
        <div className="footer-cell footer-cell-right">
          {formatCurrency(ticketMedio.qtd_horas_estetica)}
        </div>
        <div className="footer-cell footer-cell-right">
          {formatCurrency(ticketMedio.valor_pecas)}
        </div>
        <div className="footer-cell"></div>
        <div className="footer-cell"></div>
        <div className="footer-cell footer-cell-right footer-cell-total">
          {formatCurrency(ticketMedio.total_os)}
        </div>
          <div className="footer-cell"></div>
          <div className="footer-cell footer-cell-last"></div>
        </div>
      )}

      {isExpanded && (
        <div className="reports-table-footer reports-table-footer-counts" ref={lastRowRef}>
          <div className="footer-cell">
            <div className="footer-label">PERCENTUAL SOBRE RECEITA</div>
          </div>
        <div className="footer-cell"></div>
        <div className="footer-cell"></div>
        <div className="footer-cell footer-cell-right">
          {percentualReceita.qtd_horas_lataria.toFixed(2)}%
        </div>
        <div className="footer-cell"></div>
        <div className="footer-cell footer-cell-right">
          {percentualReceita.mo_estetica.toFixed(2)}%
        </div>
        <div className="footer-cell"></div>
        <div className="footer-cell footer-cell-right">
          {percentualReceita.valor_pecas.toFixed(2)}%
        </div>
        <div className="footer-cell"></div>
          <div className="footer-cell"></div>
          <div className="footer-cell"></div>
          <div className="footer-cell"></div>
          <div className="footer-cell footer-cell-last"></div>
        </div>
      )}
    </>
  );
};

export default ReportsTableFooter;
